import React from "react";
import "../style/debtDetails.css";

export const DebtPayOffProgress = (props) => {
  return (
    <div>
      {" "}
      <div className="cardHeadingWhite">Payoff Progress</div>
      <div
        className="listingContainer"
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
      >
        <React.Fragment>
          <div className="list-row-no" style={{ marginTop: "5rem" }}>
            <div className="listname-dark">
              <div style={{ color: "white" }}>Principal Paid</div>
              <div style={{ color: "white" }}>
                {props.principalPaid ? `${"$" + props.principalPaid
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : "$0"}
              </div>
            </div>
          </div>
          <div className="list-row-no" style={{ marginTop: "5rem" }}>
            <div className="listname-dark">
              <div style={{ color: "white" }}>Balance</div>
              <div style={{ color: "white" }}>
                {props.balance
                  ? `${"$" + props.balance
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                  : "$0"}
              </div>
            </div>
          </div>
        </React.Fragment>
      </div>
    </div>
  );
};
